import { useQuery } from 'react-query';
import { http } from "shared/util/http";

export const useGetDetectarParcelamentoDespesaGroupPay = (params: {
  idDespesaGroupPay: number;
  condominioId: number | null;
  deveBuscar: boolean;
}) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['detectar-parcelamento-despesa-group-pay', params.idDespesaGroupPay],
    queryFn: async () => {
      const response = await http.get<boolean>(
        `/group-pay/despesa/${params.idDespesaGroupPay}/detectar-parcelamento`,
        {
          condominioId: params.condominioId,
        }
      );
      return response.data;
    },
    enabled: params.deveBuscar && !!params.idDespesaGroupPay && !!params.condominioId,
  });

  return {
    data,
    isLoading,
    refetch,
  };
};
